import { createContext, useContext } from 'react';
import { type ApiNotification } from '@Model';

export interface NotificationHubContextProps {
    notifications: ApiNotification[];
    unreadCount: number;
    isLoading: boolean;
    onlyUnread: boolean;
    setOnlyUnread: (value: boolean) => void;
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => Promise<unknown>;
    acknowledge: (id: string) => Promise<unknown>;
    acknowledgeAll: () => Promise<unknown>;
}

const defaultValue: NotificationHubContextProps = {
    notifications: [],
    unreadCount: 0,
    isLoading: false,
    onlyUnread: false,
    setOnlyUnread: () => {},
    hasNextPage: false,
    isFetchingNextPage: false,
    fetchNextPage: async () => {},
    acknowledge: async () => {},
    acknowledgeAll: async () => {},
};

export const NotificationHubContext = createContext<NotificationHubContextProps>(defaultValue);

/**
 * Returns the notification hub state: the notifications visible to the current user, sorted
 * newest first, and the number of unread ones.
 */
export function useNotificationHub(): NotificationHubContextProps {
    return useContext(NotificationHubContext);
}
